import styled from 'styled-components';
import { color, fontSize, fontWeight, spacing } from 'theme';

export const Wrapper = styled.div`
  position: relative;
  display: inline-block;
  font-family: inherit;
`;

export const StyledTrigger = styled.div`
  display: flex;
  align-items: center;
  gap: 0.35rem;
  background: transparent;
  border: none;
  cursor: pointer;
  font: inherit;
  color: inherit;
  padding: 0;
`;

export const Chevron = styled.span<{ $isOpen: boolean; $isActive: boolean }>`
  color: ${({ $isActive }) =>
    $isActive ? color('emerald_500') : color('midnight_500')};
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid currentColor;
  transition: transform 0.2s ease;
  transform: ${({ $isOpen }) => ($isOpen ? 'rotate(180deg)' : 'none')};

  &:hover {
    color: ${color('midnight_300')};
  }
`;

export const Menu = styled.ul`
  list-style: none;
  margin: 0;
  padding: ${spacing('xs')} ${spacing('sm')};
  position: absolute;
  top: calc(100% + 4px);
  top: 24px;
  left: 50%;
  transform: translateX(-90%);
  background: #ffffff;
  border: 1px solid #d7dfe7;
  border-radius: 12px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
`;

export const MenuItem = styled.li<{ $selected?: boolean }>`
  display: block;
  padding: ${spacing('xs')} ${spacing('xs')};
  text-align: center;
  cursor: pointer;
  font-size: ${fontSize('md')};
  font-weight: ${fontWeight('medium')};
  color: ${({ $selected }) => ($selected ? '#ffffff' : '#273043')};
  background: ${({ $selected }) =>
    $selected ? `${color('emerald_500')}` : 'transparent'};

  &:hover {
    background-color: ${color('emerald_500')};
    color: white;
  }
`;
